import type { ComponentChildren } from 'preact';
import { useErrorBoundary } from 'preact/hooks';

export type ErrorBoundaryProps = {
  children: ComponentChildren;
  fallback?: ComponentChildren;
};

/**
 * Note: Only works on the client, will still throw during SSR
 */
export default function ErrorBoundary({
  children,
  fallback = null
}: ErrorBoundaryProps) {
  // eslint-disable-next-line no-console
  const [error] = useErrorBoundary((err) =>
    // eslint-disable-next-line no-console
    console.warn('Error Boundary:', err?.message)
  );

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return error ? <>{fallback}</> : <>{children}</>;
}
